import { ChatShareDialog, CopyStatus } from '@/pages/aigc/pages/Agent/ChatShare/types/chatShare';
import { createSnapshot, getSnapshotData } from '@/pages/aigc/pages/Agent/service/service';
import { v4 as uuidv4 } from 'uuid';
import React, { useCallback } from 'react';
import { processData, transformMessages } from '@/pages/aigc/pages/Agent/ChatPage/utils';
import { useErrorTips } from '@/pages/aigc/hooks/useErrorTips';
import { copyToClipboard } from '@/pages/aigc/utils/utils';
import { useIntl } from 'umi';
import { notification } from 'tea-component';
import copySuccessIcon from '@/pages/aigc/assets/svg/agent-copy-success.svg';


const useChatShareHooks=()=> {
  const showErrorTips = useErrorTips();  
  const { formatMessage } = useIntl();

  const shareOnClickHandler = (
    sessionId: string, 
    setShowShareChatDialog: React.Dispatch<React.SetStateAction<ChatShareDialog | undefined>>
  ) => {
    console.log('分享会话', sessionId, setShowShareChatDialog);
    createChatSnapshot(sessionId).then((snapshotId) => {
      if (snapshotId) {
        setShowShareChatDialog({
          isShowCopyDialog: true,
          chatSessionID: sessionId,
          snapshotID: snapshotId,
        });
      } else {
        notification.error({
          description: formatMessage({ id: "dba_common_share_failed" }),
          duration: 2000,
        });
      }
    }).catch(() => {
      notification.error({
        description: formatMessage({ id: "dba_common_share_failed" }),
        duration: 2000,
      });
    });
  };

  const createChatSnapshot = async (chatSessionID: ChatShareDialog['chatSessionID']) => {
    if(!(chatSessionID)) return;
  
    try {
      const res = await createSnapshot(chatSessionID ?? '');
      console.log('创建成功:', res.snapshot_id);
        
      return res.snapshot_id;
    } catch (e) {
      console.error('创建快照失败:', e);
      return undefined;
    }
  };

  const fetchSnapshot = async (snapshotId: string, setUsername: React.Dispatch<React.SetStateAction<string>>) => {
    try {
      const data = await getSnapshotData(
        {
          traceId: uuidv4(),
          snapshotId,
        },
        (code, msg) => {
          console.error(`错误码: ${code}, 消息: ${msg}`); 
        },
      );
        
      setUsername(data.user_id);
      let newFormatData = (transformMessages(data.messages));
      newFormatData = processData(newFormatData);
      return newFormatData;
    } catch (e) {
      console.error('获取 snapshot 数据失败:', e);
      showErrorTips(400, `获取 snapshot 数据失败: ${e}`);
    }
  };

  const handleCopyChatLink = (snapshotID:string) => copyToClipboard(snapshotID);

  const getCopyStatusMessage = useCallback((thecopyStatus: CopyStatus | undefined) => {
    const messages =
        thecopyStatus === CopyStatus.DONE
          ? formatMessage({ id: 'dba_common_copy_success' })
          : formatMessage({ id: 'dba_common_copy_failed' });
  
    return thecopyStatus !== undefined ? (
      <>
        {thecopyStatus === CopyStatus.DONE && (
          <img src={copySuccessIcon} alt="" style={{ width: 16, height: 16, marginRight: 5 }} />
        )}
        <span>{messages}</span>
      </>
    ) : null;
  }, [formatMessage]);
  
  return { 
    shareOnClickHandler, 
    createChatSnapshot, 
    fetchSnapshot, 
    handleCopyChatLink, 
    getCopyStatusMessage,
  };
};

export default useChatShareHooks;
